(function() {
    'use strict';

    angular
        .module('NaviaqWebApp')
        .controller('forgotPasswordController', forgotPasswordController);

    forgotPasswordController.$inject = [
        '$state',
        '$scope',
        '$rootScope',
        '$translate',
        'authService'
    ];

    function forgotPasswordController(
        $state,
        $scope,
        $rootScope,
        $translate,
        authService
    ) {
        $scope.requestPassword = requestPassword;

        function requestPassword(username) {
            showBusyIndicator();

            authService.requestPasswordChange(username).then(() => {
                alert($translate.instant('FORGOT_PASSWORD_REQUEST_SENT'));

                $state.go('login');
            })
            .catch(showError)
            .finally($rootScope.$broadcast('hideBusyIndicator', 'forgotPassword'));
        }

        function showError(errorText=null) {
            errorText = errorText || $translate('G_UNEXPECTED_ERROR');
            alert(errorText);
        }

        function showBusyIndicator() {
            $rootScope.$broadcast('showBusyIndicator', {
                id: 'forgotPassword',
                destination: '#login',
                style: {
                    position: 'fixed',
                    'background-color': 'rgba(0,0,0,0.25)'
                }
            });
        }
    }
})();
